import { defineMessages } from 'react-intl';

export default defineMessages({
  groupInfoMinMax: {
    id: 'booking.tickets.group_info.min_max',
    defaultMessage: 'Add a group of between {min} and {max} guests.',
  },
  groupInfoExact: {
    id: 'booking.tickets.group_info.exact',
    defaultMessage: 'Add a group of {min} {min, plural, one {guest} other {guests}}.',
  },
  groupInfoMin: {
    id: 'booking.tickets.group_info.min',
    defaultMessage: 'Add a group of {min} or more.',
  },
  groupInfoMax: {
    id: 'booking.tickets.group_info.max',
    defaultMessage: 'Add a group of {max} or less.',
  },
  discount: {
    id: 'booking.tickets.discount_rule',
    defaultMessage: 'Get {percent}% off the total price for groups of {threshold} or more.',
  },
});
